import {
    GET_SETTINGS,
    GET_SETTINGS_SUCCESS,
    GET_SETTINGS_FAILURE,
    UPDATE_SETTING_STATUS,
    UPDATE_SETTING_STATUS_SUCCESS,
    UPDATE_SETTING_STATUS_FAILURE,
    DELETE_SETTING,
    DELETE_SETTING_SUCCESS,
    DELETE_SETTING_FAILURE,
    ADD_SETTING,
    ADD_SETTING_SUCCESS,
    ADD_SETTING_FAILURE,
    EDIT_SETTING,
    EDIT_SETTING_SUCCESS,
    EDIT_SETTING_FAILURE,
    UPDATE_SETTINGS_ORDER_STATUS,
    UPDATE_SETTINGS_ORDER_STATUS_SUCCESS,
    UPDATE_SETTINGS_ORDER_STATUS_FAILURE
} from "../Constants";

export const GetSettings = (payload) => ({
    type: GET_SETTINGS,
    payload
});

export const GetSettingsSuccess = (payload) => ({
    type: GET_SETTINGS_SUCCESS,
    payload
});

export const GetSettingsFailure = (payload) => ({
    type: GET_SETTINGS_FAILURE,
    payload
});

export const UpdateSettingStatus = (payload) => ({
    type: UPDATE_SETTING_STATUS,
    payload
});

export const UpdateSettingStatusSuccess = (payload) => ({
    type: UPDATE_SETTING_STATUS_SUCCESS,
    payload
});

export const UpdateSettingStatusFailure = (payload) => ({
    type: UPDATE_SETTING_STATUS_FAILURE,
    payload
});

export const DeleteSetting = (payload) => ({
    type: DELETE_SETTING,
    payload
});

export const DeleteSettingSuccess = (payload) => ({
    type: DELETE_SETTING_SUCCESS,
    payload
});

export const DeleteSettingFailure = (payload) => ({
    type: DELETE_SETTING_FAILURE,
    payload
});

export const AddSetting = (payload) => ({
    type: ADD_SETTING,
    payload
});

export const AddSettingSuccess = (payload) => ({
    type: ADD_SETTING_SUCCESS,
    payload
});

export const AddSettingFailure = (payload) => ({
    type: ADD_SETTING_FAILURE,
    payload
});

export const EditSetting = (payload) => ({
    type: EDIT_SETTING,
    payload
});

export const EditSettingSuccess = (payload) => ({
    type: EDIT_SETTING_SUCCESS,
    payload
});

export const EditSettingFailure = (payload) => ({
    type: EDIT_SETTING_FAILURE,
    payload
});

export const UpdateSettingOrderStatus = (payload) => ({
    type: UPDATE_SETTINGS_ORDER_STATUS,
    payload
});

export const UpdateSettingOrderStatusSuccess = (payload) => ({
    type: UPDATE_SETTINGS_ORDER_STATUS_SUCCESS,
    payload
});

export const UpdateSettingOrderStatusFailure = (payload) => ({
    type: UPDATE_SETTINGS_ORDER_STATUS_FAILURE,
    payload
});